import {useState} from 'react'
import { setProductCache, useCache, removeCache } from '../services/cache'

const useProductData = (product) => {
  const [formTitle, setFormTitle] = useState(useCache('', 'formTitle', product))
  const [batch, setBatch] = useState(null)
  const [images, setImages] = useState([])
  const [frameSize, setFrameSize] = useState(useCache(null, 'frameSize', product))
  const [selectedAttributes, setSelectedAttributes] = useState(useCache([], 'selectedAttributes', product))
  const [selectedShape, setSelectedShape] = useState(useCache(null, 'selectedShape', product))
  const [hoveredAttribute, setHoveredAttribute] = useState(useCache({}, 'hoveredAttribute', product))
  const [hoveredFrameSize, setHoveredFrameSize] = useState(useCache({}, 'hoveredFrameSize', product))
  const [availableFrameSizes, setAvailableFrameSizes] = useState(useCache([], 'availableFrameSizes', product))
  const [availableProductAttributes, setAvailableProductAttributes] = useState(useCache([], 'availableProductAttributes', product))
  const [availableShapes, setAvailableShapes] = useState(useCache([], 'availableShapes', product))
  const [availableProductAttributesBySizes, setAvailableProductAttributesBySizes] = useState(useCache({}, 'availableProductAttributesBySizes', product))
  const [totalPrice, setTotalPrice] = useState(useCache(0, 'totalPrice', product))
  const [comment, setComment] = useState(useCache('', 'comment', product))
  const [showHoveredAttribute, setShowHoveredAttribute] = useState(false)
  const [showHoveredFrameSize, setShowHoveredFrameSize] = useState(false)

  // PM-425
  const is2mmSubstrateSelected = () => {
    return 1 === selectedAttributes.filter(attribute => {
      return 'matted-prints-substrate' === attribute.code &&
          '2mm - Camera Club - Hinged' === attribute.value
    }).length
  }

  const setFormTitleCache = (formTitle) => {
    setFormTitle(formTitle)
    setProductCache('formTitle', formTitle, product)
  }

  const setFrameSizeCache = (frameSize) => {
    setFrameSize(frameSize)
    setProductCache('frameSize', frameSize, product)
  }

  const setSelectedAttributesCache = (selectedAttributes) => {
    setSelectedAttributes(selectedAttributes)
    setProductCache('selectedAttributes', selectedAttributes, product)
  }

  const setSelectedShapeCache = (selectedShape) => {
    setSelectedShape(selectedShape)
    setProductCache('selectedShape', selectedShape, product)
  }

  const setHoveredAttributeCache = (hoveredAttribute) => {
    setHoveredAttribute(hoveredAttribute)
    setProductCache('hoveredAttribute', hoveredAttribute, product)
  }

  const setHoveredFrameSizeCache = (hoveredFrameSize) => {
    setHoveredFrameSize(hoveredFrameSize)
    setProductCache('hoveredFrameSize', hoveredFrameSize, product)
  }

  const setAvailableFrameSizesCache = (availableFrameSizes) => {
    setAvailableFrameSizes(availableFrameSizes)
    setProductCache('availableFrameSizes', availableFrameSizes, product)
  }

  const setAvailableProductAttributesCache = (availableProductAttributes) => {
    setAvailableProductAttributes(availableProductAttributes)
    setProductCache('availableProductAttributes', availableProductAttributes, product)
  }

  const setAvailableProductAttributesBySizesCache = (availableProductAttributesBySizes) => {
    setAvailableProductAttributesBySizes(availableProductAttributesBySizes)
    setProductCache('availableProductAttributesBySizes', availableProductAttributesBySizes, product)
  }

  const setAvailableShapesCache = (availableShapes) => {
    setAvailableShapes(availableShapes)
    setProductCache('availableShapes', availableShapes, product)
  }

  const setTotalPriceCache = (totalPrice) => {
    if(is2mmSubstrateSelected()) {
      totalPrice += 0.2 * totalPrice
    }

    setTotalPrice(totalPrice)
    setProductCache('totalPrice', totalPrice, product)
  }

  const setCommentCache = (comment) => {
    setComment(comment)
    setProductCache('comment', comment, product)
  }

  const [status, setStatus] = useState({
    error: null,
    isLoading: false,
    isLoadingAttribute: false,
    submitFormSuccess: false,
    isSubmitting: false
  })

  const [showCartModal, setShowCartModal] = useState(false)

  const resetData = () => {
    setImages([])
    setFrameSize(null)
    setSelectedAttributes([])
    setHoveredAttribute({})
    setHoveredFrameSize({})
    setTotalPrice(0)
    setComment('')
  }

  const resetCacheData = () => {
    removeCache(product)
  }

  return {
    batch,
    setBatch,
    formTitle,
    images,
    frameSize,
    selectedShape,
    selectedAttributes,
    hoveredAttribute,
    hoveredFrameSize,
    availableFrameSizes,
    availableProductAttributes,
    availableProductAttributesBySizes,
    availableShapes,
    totalPrice,
    comment,
    status,
    showCartModal,
    showHoveredAttribute,
    showHoveredFrameSize,
    setFormTitle: setFormTitleCache,
    setImages,
    setFrameSize: setFrameSizeCache,
    setSelectedAttributes: setSelectedAttributesCache,
    setHoveredAttribute: setHoveredAttributeCache,
    setHoveredFrameSize: setHoveredFrameSizeCache,
    setAvailableFrameSizes: setAvailableFrameSizesCache,
    setAvailableProductAttributes: setAvailableProductAttributesCache,
    setAvailableShapes: setAvailableShapesCache,
    setTotalPrice: setTotalPriceCache,
    setSelectedShape: setSelectedShapeCache,
    setComment: setCommentCache,
    setAvailableProductAttributesBySizes: setAvailableProductAttributesBySizesCache,
    setStatus,
    setShowCartModal,
    setShowHoveredAttribute,
    setShowHoveredFrameSize,
    resetData,
    resetCacheData,
    is2mmSubstrateSelected
  }
}

export default useProductData
